export function stopPropagation(event: Event) {
  event.stopPropagation();
}
